import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react";
import { Alert01Icon, Cancel01Icon } from "@hugeicons/core-free-icons";
import { cn } from "@/lib/utils";
import { useCreditsBalance } from "@/lib/hooks/use-credits";

const DISMISSED_KEY = "rayloop_low_credit_banner_dismissed";

export function LowCreditBanner() {
  const navigate = useNavigate();
  const { data: balance } = useCreditsBalance();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISSED_KEY) === "1"
  );

  if (dismissed || !balance) return null;

  const isLow =
    balance.plan !== "free" &&
    balance.plan_credits_monthly > 0 &&
    balance.total / balance.plan_credits_monthly < 0.2;

  if (!isLow) return null;

  function handleDismiss() {
    sessionStorage.setItem(DISMISSED_KEY, "1");
    setDismissed(true);
  }

  return (
    <div
      className={cn(
        "relative flex items-center gap-3 rounded-lg border border-amber-500/30",
        "bg-amber-500/10 px-4 py-3 text-sm text-amber-600 dark:text-amber-400",
      )}
    >
      <HugeiconsIcon icon={Alert01Icon} className="size-4 shrink-0" />
      <span className="flex-1">
        You're running low on credits ({balance.total.toLocaleString()} remaining).{" "}
        <button
          className="font-medium underline underline-offset-2 hover:no-underline"
          onClick={() => navigate("/settings?upgrade=1")}
        >
          Top up credits
        </button>
      </span>
      <button
        onClick={handleDismiss}
        className="shrink-0 opacity-60 hover:opacity-100 transition-opacity"
        aria-label="Dismiss"
      >
        <HugeiconsIcon icon={Cancel01Icon} className="size-4" />
      </button>
    </div>
  );
}
